import {
  mdiPlus as mdiAdd,
  mdiCalendar,
  mdiCancel,
  mdiTag as mdiCategories,
  mdiFileDocumentRefresh as mdiChangesRequested,
  mdiCheck,
  mdiCheckCircle,
  mdiClose,
  mdiCloseCircle,
  mdiMinus as mdiDash,
  mdiDelete,
  mdiDownload,
  mdiPencil as mdiEdit,
  mdiCircleOutline as mdiEmptyCircle,
  mdiAlertCircle as mdiError,
  mdiPaperclip as mdiFile,
  mdiUpload as mdiFileUpload,
  mdiFilter,
  mdiHelpCircle as mdiHelp,
  mdiInformation as mdiInfo,
  mdiMusicNoteEighth as mdiMusic,
  mdiDotsHorizontal as mdiOverflowMenu,
  mdiCurrencyUsd as mdiPayment,
  mdiCurrencyUsdOff as mdiPaymentOff,
  mdiTimerSand as mdiPending,
  mdiRefresh,
  mdiMagnify as mdiSearch,
  mdiDecagram as mdiTierBadge,
  mdiMagnify as mdiView,
} from "@mdi/js";

// TODO: Extract to a sensible location
export const appIcons = {
  mdiAdd,
  mdiCancel,
  mdiCalendar,
  mdiCategories,
  mdiCheck,
  mdiCheckCircle,
  mdiClose,
  mdiCloseCircle,
  mdiChangesRequested,
  mdiDash,
  mdiDelete,
  mdiDownload,
  mdiEdit,
  mdiEmptyCircle,
  mdiError,
  mdiFile,
  mdiFileUpload,
  mdiFilter,
  mdiHelp,
  mdiInfo,
  mdiMusic,
  mdiOverflowMenu,
  mdiPayment,
  mdiPaymentOff,
  mdiRefresh,
  mdiPending,
  mdiSearch,
  mdiTierBadge,
  mdiView,
};
